<template lang="">
    <Head title="Termos de Uso" />
        <PagesLayout>
        <Heading title="Termos De Uso" class="xl:px-[220px] xl:pt-6 sm:pl-6 sm:pt-6"/>
            <div class="p-4 px-5 xl:px-[15vw] min-h-[70vh] component-background-desktop" >
                <button @click="goBack" :class="stateBack" class="py-5 back-sm hover:text-blue-600 hover:underline text-blue-500">Voltar</button>
                <article class="mb-5">
                    <div v-html="term.text"></div>
                </article>
            </div>
            </PagesLayout>
</template>

<script>
import { Head } from "@inertiajs/inertia-vue3";
import Heading from "@/Components/UI/Texts/Heading.vue";
import HeaderComponent from "@/Components/Header.vue";
import FooterComponent from "@/Components/Footer.vue";
import Wysiwyg from "@/Components/UI/Texts/Wysiwyg.vue";
import PagesLayout from "@/Layouts/Pages.vue";

export default {
  components: {
    HeaderComponent,
    FooterComponent,
    Heading,
    Head,
    Wysiwyg,
    PagesLayout
  },
  props: {
      term: Object
  },
  methods: {
        goBack(){
            return window.history.go(-1);
        }
    }
};
</script>
